import React from 'react';
import { Navigation, A11y, Zoom } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import Roon from '../../images/Window Profiles/Carausel Images/roon.png';
import CarauselImage0 from '../../images/Window Profiles/Carausel Images/0.png';
import CarauselImage1 from '../../images/Window Profiles/Carausel Images/1.png';
import CarauselImage2 from '../../images/Window Profiles/Carausel Images/2.png';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/zoom';
import 'swiper/css/navigation';
import './main.css'

export default function WindowProfiles() {
    return (
        <>
            <div className="window-profiles">
                <div className="window-theme-top-title"></div>
                <div className="roon-top-left"></div>
                <div className="roon-bottom-left"></div>
                <div className="roon-bottom-left"></div>
                <div className="roon-top-right"></div>
                <div className="roon-bottom-right"></div>
                <div className="window-theme-bottom-title"></div>
                <h2 className="title">Виды оконных профилей</h2>
                <div className="window-slider">
                    <Swiper
                        className="carausel"
                        modules={[Navigation, A11y, Zoom]}
                        spaceBetween={55}
                        slidesPerView={3}
                        navigation={true}
                        zoom={true}
                        onSwiper={(swiper) => console.log(swiper)}
                        onSlideChange={() => console.log('slid</Swiper>e change')}>
                        <SwiperSlide className="carausel-box">
                            <div className="carausel-box-image">
                                <button>Эконом</button>
                                <div className="images">
                                    <img src={CarauselImage0} alt="error" />
                                    <img src={Roon} alt="error" />
                                </div>
                            </div>
                            <div className="carausel-box-title">
                                <h4>Оконные профили Alpenprof</h4>
                            </div>
                            <div className='carausel-paragraph'>
                                <p><b>Страна:</b><span> Россия</span></p>
                                <p><b>Касс профиля:</b><span> С (Эконом):</span></p>
                                <p><b>Толщина стенки:</b><span> 2,5 мм:</span></p>
                                <p><b>Ширина профиля:</b><span> 58 мм</span></p>
                                <p><b>Макс.ширина стеклопакета:</b><span> от 24 до 32 мм</span></p>
                            </div>
                            <div className="carausel-box-sum">
                                <p>от </p>
                                <p>2 200 руб.</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="carausel-box">
                            <div className="carausel-box-image">
                                <button className='Standard'>Стандарт</button>
                                <div className="images">
                                    <img src={CarauselImage1} alt="error" />
                                    <img src={Roon} alt="error" />
                                </div>
                            </div>
                            <div className="carausel-box-title">
                                <h4>Оконные профили Alpenprof</h4>
                            </div>
                            <div className='carausel-paragraph'>
                                <p><b>Страна:</b><span> Россия</span></p>
                                <p><b>Касс профиля:</b><span> С (Эконом):</span></p>
                                <p><b>Толщина стенки:</b><span> 2,5 мм:</span></p>
                                <p><b>Ширина профиля:</b><span> 58 мм</span></p>
                                <p><b>Макс.ширина стеклопакета:</b><span> от 24 до 32 мм</span></p>
                            </div>
                            <div className="carausel-box-sum">
                                <p>от </p>
                                <p>2 200 руб.</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="carausel-box">
                            <div className="carausel-box-image">
                                <button className='Standard'>Стандарт</button>
                                <div className="images">
                                    <img src={CarauselImage2} alt="error" />
                                    <img src={Roon} alt="error" />
                                </div>
                            </div>
                            <div className="carausel-box-title">
                                <h4>Оконные профили Alpenprof</h4>
                            </div>
                            <div className='carausel-paragraph'>
                                <p><b>Страна:</b><span> Россия</span></p>
                                <p><b>Касс профиля:</b><span> С (Эконом):</span></p>
                                <p><b>Толщина стенки:</b><span> 2,5 мм:</span></p>
                                <p><b>Ширина профиля:</b><span> 58 мм</span></p>
                                <p><b>Макс.ширина стеклопакета:</b><span> от 24 до 32 мм</span></p>
                            </div>
                            <div className="carausel-box-sum">
                                <p>от </p>
                                <p>2 200 руб.</p>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="carausel-box">
                            <div className="carausel-box-image">
                                <button>Эконом</button>
                                <div className="images">
                                    <img src={CarauselImage0} alt="error" />
                                    <img src={Roon} alt="error" />
                                </div>
                            </div>
                            <div className="carausel-box-title">
                                <h4>Оконные профили Alpenprof</h4>
                            </div>
                            <div className='carausel-paragraph'>
                                <p><b>Страна:</b><span> Россия</span></p>
                                <p><b>Касс профиля:</b><span> С (Эконом):</span></p>
                                <p><b>Толщина стенки:</b><span> 2,5 мм:</span></p>
                                <p><b>Ширина профиля:</b><span> 58 мм</span></p>
                                <p><b>Макс.ширина стеклопакета:</b><span> от 24 до 32 мм</span></p>
                            </div>
                            <div className="carausel-box-sum">
                                <p>от </p>
                                <p> 2 200 руб.</p>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </>
    )
}
